export default {
  id: (state) => state.id,
  loading: (state) => state.loading,
  reInviteLoading: (state) => state.reInviteLoading,
  actionLoading: (state) => state.actionLoading,
  formData: (state) => state.formData,
  items: (state) => state.items,
  selected: (state) => state.selected,
  filters: (state) => state.filters,
  paramsQueryFilters: (state) => ({ ...state.filters, search: state.search }),
  total: (state) => state.total,
  totalAll: (state) => state.totalAll,
  search: (state) => state.search,
  sorting: (state) => state.sorting,
  successFileLoaded: (state) => state.successFileLoaded,
  uploadErrors: (state) => state.uploadErrors,
  formDataPaymentInfo: (state) => state.formDataPaymentInfo,
}
